import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "../src/components/home/Home.jsx";
import Header from "../src/components/header/Header.jsx";
import Footer from "../src/components/footer/Footer.jsx";
import About from "../src/pages/about/About.jsx";
import Contact from "../src/pages/contact/Contact.jsx";
import Location from "../src/pages/location/Location.jsx";
import Services from "../src/pages/services/Services.jsx";
import Testimonials from "./pages/testimonials/Testimonials.jsx";
import Benefits from "../src/pages/benefits/Benefits.jsx";
import "./App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/locations" element={<Location />} />
        <Route path="/services" element={<Services />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/benefits" element={<Benefits />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
